import { render, staticRenderFns } from "./SwiperContainer.vue?vue&type=template&id=e1ec05e2"
import script from "./SwiperContainer.vue?vue&type=script&lang=js"
export * from "./SwiperContainer.vue?vue&type=script&lang=js"
import style0 from "./SwiperContainer.vue?vue&type=style&index=0&id=e1ec05e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports